





















import { ref, computed, onBeforeUnmount } from '@vue/composition-api';
import { TabType, CallStatus, AsrFrom } from '@/const/business';
import dayjs from 'dayjs';
import { deepClone } from '@/utils/utils';
import avatarMan from '@/assets/images/avatar-man.png';
import avatarWoman from '@/assets/images/avatar-woman.png';
export default {
  setup(props, { root, emit }: any) {
    const innerDivXaxis = ref(0);
    const innerDivYaxis = ref(0);
    const drag = ($event) => {
      // 计算鼠标点击位置div内的偏移量
      innerDivXaxis.value = 170 - $event.offsetX;
      innerDivYaxis.value = 128 - $event.offsetY;
      emit('drag', innerDivXaxis.value, innerDivYaxis.value);
    };
    const outCallPatient = computed(() => root.$store.state.currentOutCallPatient);

    const returnOutCall = () => {
      root.$store.commit('SWITCH_TAB_INDEX', TabType.outboundCall);
      const query = root.$store.state.outCallRouter;
      const patientItem = root.$store.state.currentOutCallPatient;
      root.$store.commit('SET_SELECT_LIST', [patientItem]);
      root.$router.push({
        path: '/default/intelligentFollowUpDetail',
        query,
      });
      const divCallPhone: HTMLElement = document.querySelector('.fix-out-call') as HTMLElement;
      divCallPhone && (divCallPhone.style.display = 'none');
    };

    // 文字内容处理
    const dealWordContent = (data) => {
      if (root.$store.state.callStatus !== CallStatus.online) return;
      const callRecordDetailValue = root.$store.state.callRecordDetail;
      const wordObj = deepClone(data);
      wordObj.sendDirection = data.flow === 'OUT' ? AsrFrom.dialer : AsrFrom.called;
      wordObj.slice_type = data.result.slice_type;
      wordObj.content = data.result.voice_text_str;
      if (!callRecordDetailValue.length && wordObj.content) {
        callRecordDetailValue.push(wordObj);
      } else {
        if (!wordObj.content) return;
        let i = 0;
        const len = callRecordDetailValue.length;
        for (; i < len; i++) {
          if (
            callRecordDetailValue[i]?.result
            && callRecordDetailValue[i].flow === wordObj.flow
            && callRecordDetailValue[i].result.asr_timestamp === wordObj.result.asr_timestamp
          ) {
            callRecordDetailValue.splice(i, 1, wordObj);
            root.$store.state.callRecordDetail = callRecordDetailValue;
            return;
          }
        }
        if (i === len && wordObj.content) {
          callRecordDetailValue.push(wordObj);
        }
        root.$store.state.callRecordDetail = callRecordDetailValue;
      }
    };

    const closeTelephone = () => {
      clearInterval(root.$store.state.tccTimer);
      if (root.$store.state.callStatus === CallStatus.over) return;
      root.$store.state.callStatus = CallStatus.over;
      root.$store.commit('SET_OUT_CALLING', false);
      root.$store.commit('SET_OUT_CALL_COMPONENT_SHOW', false);
      const { qdTalkTime } = root.$store.state;
      const endSymbolObj = {
        type: CallStatus.over,
        qdTalkTime,
        showTime: true,
        startTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm'),
      };
      window.tccc.Call.stopASR({
        sessionId: root.$store.state.tccSessionId,
      });
      root.$store.state.qdTalkTime = 0;
      root.$store.state.callRecordDetail.push(endSymbolObj);
    };

    /**
     * 初始化socket
     */
    const initSocket = () => {
      window.tccc.on(window.tccc.events.asr, (data) => {
        dealWordContent(data);
        console.log('%c Line:106 🌮 data', 'color:#ed9ec7', data);
      });
      window.tccc.on(window.tccc.events.sessionEnded, closeTelephone);
      window.tccc.on(window.tccc.events.calloutAccepted, () => {
        clearInterval(root.$store.state.tccTimer);
        root.$store.state.intervalTime = 0;
        root.$store.state.qdTalkTime = 0;
        root.$store.state.callStatus = CallStatus.online;
        root.$store.commit('SET_OUT_CALLING', true);
        root.$store.state.tccTimer = setInterval(() => {
          if (root.$store.state.callStatus === CallStatus.over) {
            clearInterval(root.$store.state.tccTimer);
            return;
          }
          root.$store.state.qdTalkTime = root.$store.state.qdTalkTime + 1;
          if (
            (root.$store.state.intervalTime === 0
              || root.$store.state.qdTalkTime - root.$store.state.intervalTime >= 300)
            && root.$store.state.callStatus === CallStatus.online
          ) {
            root.$store.state.intervalTime = root.$store.state.qdTalkTime;
            root.$store.state.callRecordDetail.push({
              showTime: true,
              startTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm'),
              type: CallStatus.online,
            });
          }
        }, 1000);
      });
      window.tccc.on(window.tccc.events.statusChanged, (data) => {
        if (data.status === 'free') {
          closeTelephone();
        }
      });
    };

    onBeforeUnmount(() => {
      clearInterval(root.$store.state.tccTimer);
    });

    initSocket();
    return {
      innerDivXaxis,
      innerDivYaxis,
      returnOutCall,
      outCallPatient,
      drag,
      avatarMan,
      avatarWoman,
    };
  },
};
